import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "horizontal_rule",
  "use": "horizontal_rule-usage",
  "viewBox": "0 0 640 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\" id=\"horizontal_rule\"><path fill=\"currentColor\" d=\"M640 239.87v31.26A15.88 15.88 0 01624.14 287H15.87A15.88 15.88 0 010 271.13v-31.26A15.88 15.88 0 0115.87 224h608.27A15.88 15.88 0 01640 239.87z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol